import { createContext } from 'react';
import type {
  Customer,
  CustomerRequestOtpRequest,
  CustomerVerifyOtpRequest,
  User,
} from '@billx/types';

export interface UserAuthPayload {
  phone: string;
  otp: string;
  referralCode?: string;
  invitationCode?: string;
  deviceId?: string;
  deviceInfo?: {
    type: string;
    platform?: string;
    deviceName?: string;
    model?: string;
    browser?: string;
    osVersion?: string;
    appVersion?: string;
  };
}

export interface UserAuthContextType {
  isLoading: boolean;
  authUser: User | null;
  requestOtp: (phone: string) => Promise<string>;
  verifyOtp: (payload: UserAuthPayload) => Promise<void>;
  logout: () => Promise<void>;
  isLoggingOut: boolean;
}

export const UserAuthContext = createContext<UserAuthContextType | undefined>(
  undefined
);

export interface CustomerAuthContextType {
  authCustomer: Customer | null;
  isLoading: boolean;
  isLoggingOut: boolean;
  initSession: (businessId: string) => Promise<void>;
  requestOtp: (payload: CustomerRequestOtpRequest) => Promise<string>;
  verifyOtp: (payload: CustomerVerifyOtpRequest) => Promise<void>;
  logout: (businessId: string) => Promise<void>;
}

export const CustomerAuthContext = createContext<
  CustomerAuthContextType | undefined
>(undefined);

export interface WebSocketContextType {
  socket: any | null;
  isConnected: boolean;
  joinRoom: (type: any, id: string) => void;
  leaveRoom: (type: any, id: string) => void;
  subscribe: (params: {
    event: string;
    handler: (payload: any) => void;
  }) => () => void;
}

export const UserWebSocketContext = createContext<
  WebSocketContextType | undefined
>(undefined);
export const CustomerWebSocketContext = createContext<
  WebSocketContextType | undefined
>(undefined);
